const slides = [
  {
    question: "Languages",
    type: "checkbox",
    options: [
      "C",
      "C++",
      "C#",
      "Javascript",
      "React",
      "Vue",
      "Angular",
      "Python",
      "Ruby",
      "Perl",
      "HTML",
      "CSS",
    ],
  },
  {
    question: "Base de données",
    type: "checkbox",
    options: [
      "MySQL",
      "PostgreSQL",
      "Oracle",
      "SQL Server",
      "Mongodb",
      "Cassandra",
      "CouchDB",
      "DynamoDB",
      "Redis",
    ],
  },
  {
    question: "Qualités recherchées",
    type: "checkbox",
    options: [
      "Autonomie",
      "Adaptabilité",
      "Prise d'initiative",
      "inspirant",
      "Ouvert à d'autres outils, languages",
      "rigoureux",
      "Communiquant",
      "Passionné",
      "Créatif",
      "Résolveur de problèmes",
    ],
  },
  {
    question: "Outils",
    type: "checkbox",
    options: [
      "Git",
      "Docker",
      "Node",
      "VMware",
      "VirtualBox",
      "KVM",
      "VS Code",
      "Postman",
      "Trello",
      "Autres",
    ],
  },
  {
    question: "Télétravail",
    type: "checkbox",
    options: [
      "1 jour/semaine",
      "2 jours/semaine",
      "3 jours/semaine",
      "4 jours/semaine",
      "Full remote",
      "à définir",
      "pas de télétravail",
    ],
  },
  {
    question: "Avantages",
    type: "checkbox",
    options: [
      "Tickets restaurant",
      "véhicule",
      "Titre de transport",
      "salle de sport",
    ],
  },
  {
    question: "Salaire annuel brut",
    type: "checkbox",
    options: [
      "30000€ à 35000€",
      "35000€ à 40000€",
      "40000€ à 45000€",
      "45000€ à 50000€",
      "+50000€",
      "à définir",
    ],
  },
];

export default slides;
